// assets
import styles from "@/assets/styles/components/Modals/completed-step-modal.module.scss";
import IntercomIcon from "@/components/icons/IntercomIcon";

const progressTitle = "Now that’s progress!";

export const COMPLETED_STEPS = [
  {
    stepKey: "search",
    title: progressTitle,
    description: (userName: string) => (<>
      <p>Hi {userName}!</p>
      <p>Congratulations on your first official search on lo:live! You’re on your way to finding the perfect space.</p>
      <p>The next step is creating your campaign. Check out the video below to learn how:</p>
    </>),
    buttonText: null,
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/getting-started_3_planning_and_booking_campaigns.mp4"
  },
  {
    stepKey: "create-campaign",
    title: progressTitle,
    description: (userName: string) => (<>
      <p>{userName}, congratulations on creating your first campaign!</p>
      <p>Campaigns allow you to group spaces together for each project that you’re working on.</p>
      <p>
        Next, populate it with  spaces that you like, adding them to your campaign by
        clicking the favourite (heart) icon.
      </p>
      <p>Check out the video below to learn how:</p>
    </>),
    buttonText: "Add space to campaign",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/completed_step_add_space_and_dates_to_campaign.mp4",
  },
  {
    stepKey: "create-campaign-add-space",
    title: progressTitle,
    description: (userName: string) => (<>
      <p>{userName}, you’ve just created your first campaign and added a space!</p>
      <p>Campaigns allow you to group spaces together for each project you’re working on.</p>
      <p>Next, add your dates of interest to the space so you can option or book it! </p>
      <p>Check out the video below to learn how:</p>
    </>),
    buttonText: "Add dates to space",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/completed_step_add_dates_to_space_on_campaign.mp4",
  },
  {
    stepKey: "add-space",
    title: "You’re one step closer!",
    description: (userName: string) => (<>
      <p>{userName}, you’ve just added your first space to a campaign!</p>
      <p>You’re now able to add your dates of interest to the space so that you can option or book it!</p>
      <p>
        Some spaces are ‘price on application’ - for these, click the ‘send enquiry’ button on the
        space or in your campaign planner.
      </p>
      <p>Check out the video below to see how to add dates, option and book:</p>
    </>),
    buttonText: "Add dates to space",
    video: "https://d2gfhx6otln0v7.cloudfront.net/media/files/completed_step_add_dates_to_space_on_campaign.mp4"
  },
  {
    stepKey: "option-space",
    title: "It’s nearly in the bag!",
    description: (userName: string) => (<>
      <p>{userName}, the space is nearly yours! Congratulations on requesting your first option.</p>
      <p>
        There’s just one more step to go - booking!
        Once your option has been approved, click ‘book’ on the space in your campaign planner.
        Click below to go to your campaign.
      </p>
    </>),
    buttonText: "Book space",
    video: null
  },
  {
    stepKey: "book-space",
    title: "You made it!",
    description: (userName: string) => (<>
      <p>{userName}, congratulations on your first booking!</p>
      <p>After your booking has been accepted by the location you will receive an email with next steps.</p>
      <p>
        If there’s anything more we can do for you, please click the
        {" "}<IntercomIcon className={styles["locl-completed-step-modal__intercom-icon"]}/>{" "}
        icon in the bottom right of our site to speak to us directly, or email us at
        {" "}<a href="mailto:thecrew@locationlive.com" className={styles["locl-completed-step-modal__link_gray"]}>thecrew@locationlive.com</a>
      </p>
      <p>Have a great day!</p>
      <p>Thanks,</p>
      <p>The lo:live crew</p>
    </>),
    buttonText: null,
    video: null
  },
];
